import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import AppLayout from '@/components/layout/AppLayout';

export default function ProtectedRoute({
  children,
  requiredProfile,
}: {
  children: React.ReactNode;
  requiredProfile?: 'admin' | 'colaborador' | 'any';
}) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-portal-gray-50">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-portal-purple border-t-transparent rounded-full animate-spin mx-auto mb-3"></div>
          <p className="text-sm text-portal-gray-500">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.mustChangePassword && location.pathname !== '/alterar-senha') {
    return <Navigate to="/alterar-senha" replace />;
  }

  if (requiredProfile && requiredProfile !== 'any' && user.perfil !== requiredProfile) {
    // Redireciona para a página correta baseada no perfil
    if (user.perfil === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    }
    return <Navigate to="/colaborador" replace />;
  }

  return <AppLayout>{children}</AppLayout>;
}
